import React, {useEffect, useLayoutEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledCollectionEntitySideBarWrapper
  from 'components/templates/Wrappers/Collections/Entities/CollectionEntitySideBarWrapper/CollectionEntitySideBarWrapper.styles';
import CollectionEntitiesList from 'components/organisms/Lists/CollectionEntitiesList/CollectionEntitiesList';
import utils from 'helpers/utils';
import {useLinkNavigate, useSplitPath} from 'helpers/hooks/links';
import {useProfile} from 'components/organisms/Providers/ProfileProvider/ProfileProvider';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';

const CollectionEntitySideBarWrapper = React.forwardRef((props, ref) => {
  const {
    stateKey,
    ...innerProps
  } = useComponentProps({
    anchor: 'left',
    ...props
  }, 'CollectionEntitySideBarWrapper');

  const tableProvider = useTable();
  const profileProvider = useProfile();

  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const [open, setOpen] = useState(!lgDown);
  const [animate, setAnimate] = useState(false);
  const [initialised, setInitialised] = useState(false);

  const navigate = useLinkNavigate();

  const [pathPrefix, pathPostfix] = useSplitPath('entities');
  const pathPostSplit = pathPostfix.split('/');
  const postFix = pathPostSplit.length > 1 ? `/${pathPostSplit.slice(1).join('/')}` : '';
  const pathKey = pathPostSplit[1] ?? 'profile';

  const pathEntityId = pathPostSplit[0];
  const selectedEntityId = tableProvider.selected()?.entityId;
  const entityLoaded = +selectedEntityId === +pathEntityId;

  const handleClick = (e, entity) => {
    navigate({
      event: e,
      to: `${pathPrefix}/${entity.entityId}${postFix}`,
      keepSearchParams: true
    });
  };

  useEffect(() => {
    setInitialised((current) => {
      return current || entityLoaded
    });
  }, [entityLoaded]);

  useLayoutEffect(() => {
    setAnimate(false);
  }, [pathKey]);

  useEffect(() => {
    setAnimate(true);
  }, [pathKey]);

  const handleContextToggle = (e, open) => {
    setOpen(open);
  }

  useLayoutEffect(() => {
    setOpen(!lgDown);
  }, [lgDown]);

  innerProps.size = innerProps.size ?? 'small';
  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledCollectionEntitySideBarWrapper ref={ref} {...innerProps}
                                               variant={lgDown ? 'temporary' : 'standard'}
                                               context={<CollectionEntitiesList onClick={initialised ? handleClick : null} />}
                                               open={open && Boolean(profileProvider.state?.showSidebar?.[stateKey ?? pathKey])}
                                               onToggle={handleContextToggle}
                                               animate={animate}/>
});

CollectionEntitySideBarWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]),
  stateKey: PropTypes.string
};

export default CollectionEntitySideBarWrapper;
